import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import academicService from './academicService'
import axios from 'axios'

// Get Courses
export const ListCourse = createAsyncThunk('course-list', async (params: {}, thunkAPI) => {
  try {
    return await academicService.courseList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Course
export const createCourse = createAsyncThunk('course-create', async (data: {}, thunkAPI) => {
  try {
    return await academicService.courseCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Course id
export const editCourse = createAsyncThunk('course-edit', async (id: string, thunkAPI) => {
  try {
    return await academicService.courseEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Course
export const deleteCourse = createAsyncThunk('course-delete', async (id: string, thunkAPI) => {
  try {
    return await academicService.courseDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// View Course
export const viewCourse = createAsyncThunk('course-view', async (id: string, thunkAPI) => {
  try {
    return await academicService.courseView(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Course Lessons
export const listCourseLessons = createAsyncThunk(
  'course-lesson-list',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.courseLessonList(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const listCourseSessionLessons = createAsyncThunk(
  'course-lesson-list-by-session',
  async (
    {id, lesson_number}: {id: string; lesson_number: number}, // Accept an object with id and lesson_number
    thunkAPI
  ) => {
    try {
      return await academicService.courseLessonBySessionList(id, lesson_number) // Pass both parameters
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create Course Lesson
export const createCourseLesson = createAsyncThunk(
  'course-lesson-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.courseLessonCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete CourseLesson
export const deleteCourseLesson = createAsyncThunk(
  'course-lesson-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.courseLessonDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete CourseLesson
export const toggleCourseLesson = createAsyncThunk(
  'course-lesson-toggle',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.courseLessonToggleView(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get PublicationCategory
export const ListPublicationCategory = createAsyncThunk(
  'publication-category-list',
  async (params: {}, thunkAPI) => {
    try {
      return await academicService.publicationCategoryList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create PublicationCategory
export const createPublicationCategory = createAsyncThunk(
  'publication-category-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.publicationCategoryCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get PublicationCategory id
export const editPublicationCategory = createAsyncThunk(
  'publication-category-edit',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.publicationCategoryEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete PublicationCategory
export const deletePublicationCategory = createAsyncThunk(
  'publication-category-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.publicationCategoryDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get PublicationField
export const ListPublicationField = createAsyncThunk(
  'publication-field-list',
  async (params: {}, thunkAPI) => {
    try {
      return await academicService.publicationFieldList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create PublicationField
export const createPublicationField = createAsyncThunk(
  'publication-field-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.publicationFieldCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get PublicationField id
export const editPublicationField = createAsyncThunk(
  'publication-field-edit',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.publicationFieldEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete PublicationField
export const deletePublicationField = createAsyncThunk(
  'publication-field-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.publicationFieldDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campuses Faculty
export const ListCampusFaculty = createAsyncThunk(
  'campus-faculty-list',
  async (params: {}, thunkAPI) => {
    try {
      return await academicService.campusFacultyList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create CampusFaculty
export const createCampusFaculty = createAsyncThunk(
  'campus-faculty-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.campusFacultyCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get CampusFaculty id
export const editCampusFaculty = createAsyncThunk(
  'campus-faculty-edit',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.campusFacultyEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete CampusFaculty
export const deleteCampusFaculty = createAsyncThunk(
  'campus-faculty-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.campusFacultyDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campuses Department
export const ListCampusDepartment = createAsyncThunk(
  'campus-department-list',
  async (params: {}, thunkAPI) => {
    try {
      return await academicService.campusDepartmentList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create CampusDepartment
export const createCampusDepartment = createAsyncThunk(
  'campus-department-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.campusDepartmentCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get CampusDepartment id
export const editCampusDepartment = createAsyncThunk(
  'campus-department-edit',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.campusDepartmentEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete CampusDepartment
export const deleteCampusDepartment = createAsyncThunk(
  'campus-department-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.campusDepartmentDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get publications
export const ListPublication = createAsyncThunk(
  'publication-list',
  async (params: {}, thunkAPI) => {
    try {
      return await academicService.publicationList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create publication
export const createPublication = createAsyncThunk(
  'publication-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.publicationCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get publication id
export const editPublication = createAsyncThunk(
  'publication-edit',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.publicationEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete publication
export const deletePublication = createAsyncThunk(
  'publication-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.publicationDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// getAuthors
export const getAuthors = createAsyncThunk('get-authors', async (type: string, thunkAPI) => {
  try {
    return await academicService.getAuthors(type)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Toggle Publication
export const togglePublication = createAsyncThunk(
  'publication-toggle',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.publicationToggle(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// rate Publication
export const ratePublication = createAsyncThunk<
  any,
  {id: string; rate: string},
  {rejectValue: {errors: string[]}}
>('publication-rating', async ({id, rate}, thunkAPI) => {
  try {
    return await academicService.publicationRating(id, rate)
  } catch (error: any) {
    if (error.response && error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get VideoLibrarys
export const ListVideoLibrary = createAsyncThunk(
  'video-library-list',
  async (params: {}, thunkAPI) => {
    try {
      return await academicService.videoLibraryList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create VideoLibrary
export const createVideoLibrary = createAsyncThunk(
  'video-library-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.videoLibraryCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get VideoLibrary id
export const editVideoLibrary = createAsyncThunk(
  'video-library-edit',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.videoLibraryEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete VideoLibrary
export const deleteVideoLibrary = createAsyncThunk(
  'video-library-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.videoLibraryDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Toggle VideoLibrary
export const toggleVideoLibrary = createAsyncThunk(
  'video-library-toggle',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.videoLibraryToggle(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create emailToRelatedStudents
export const emailToRelatedStudents = createAsyncThunk(
  'email-to-related-students',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.relatedStudentsEmail({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListTimeTable = createAsyncThunk('timetable-list', async (lang: string, thunkAPI) => {
  try {
    return await academicService.timeTableList(lang)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteTimeTableCourse = createAsyncThunk(
  'timetable-course-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.timeTableCourseDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createTimeTableCourse = createAsyncThunk(
  'timetable-course-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.timeTableCourseCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editTimeTableCourse = createAsyncThunk(
  'timetable-course-edit',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.timeTableCourseEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteTimeTableProgram = createAsyncThunk(
  'timetable-program-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.timeTableProgramDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createTimeTableProgram = createAsyncThunk(
  'timetable-program-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.timeTableProgramCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editTimeTableProgram = createAsyncThunk(
  'timetable-program-edit',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.timeTableProgramEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteTimeTableSemester = createAsyncThunk(
  'timetable-semester-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.timeTableSemesterDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createTimeTableSemester = createAsyncThunk(
  'timetable-semester-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.timeTableSemesterCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editTimeTableSemester = createAsyncThunk(
  'timetable-semester-edit',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.timeTableSemesterEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteTimeTableSchedule = createAsyncThunk(
  'timetable-schedule-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.timeTableScheduleDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createTimeTableSchedule = createAsyncThunk(
  'timetable-schedule-create',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.timeTableScheduleCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const editTimeTableSchedule = createAsyncThunk(
  'timetable-schedule-edit',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.timeTableScheduleEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const toggleCourse = createAsyncThunk('course-toggle', async (id: string, thunkAPI) => {
  try {
    return await academicService.courseToggle(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const toggleProgram = createAsyncThunk('program-toggle', async (id: string, thunkAPI) => {
  try {
    return await academicService.programToggle(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AddStudentToCourse = createAsyncThunk('add-student', async (data: {}, thunkAPI) => {
  try {
    return await academicService.addStudent({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListCourseStudents = createAsyncThunk(
  'course-students-list',
  async (
    {target_type, target_id}: {target_type: string; target_id: string}, // Accept an object with target_type and target_id
    thunkAPI
  ) => {
    try {
      return await academicService.courseStudentsList(target_type, target_id) // Pass both parameters
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteStudentCourse = createAsyncThunk(
  'student-course-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.courseStudentDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CourseStudentsDelete = createAsyncThunk(
  'students-course-delete',
  async (data: {}, thunkAPI) => {
    try {
      return await academicService.courseStudentsDelete({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetLecturers = createAsyncThunk('get-lecturers', async (_, thunkAPI) => {
  try {
    return await academicService.getLecturers()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const TimeTablePrint = createAsyncThunk('timetable-print', async (id: string, thunkAPI) => {
  try {
    return await academicService.printTimeTable(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ApproveStudentScore = createAsyncThunk(
  'approve-students-score',
  async ({target_id, target_type}: {target_id: string; target_type: string}, thunkAPI) => {
    try {
      return await academicService.approveStudentScore(target_id, target_type)
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintStdAttendance = createAsyncThunk(
  'student-att-print',
  async ({courseId, type}: {courseId: string; type: string}, thunkAPI) => {
    try {
      return await academicService.attReportPrint(courseId, type)
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CourseEvReport = createAsyncThunk(
  'course-ev-report',
  async ({tarId, tarType}: {tarId: string; tarType: string}, thunkAPI) => {
    try {
      return await academicService.courseEvReport(tarId, tarType)
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const UpdateTimeSlot = createAsyncThunk('update-timeslot', async (data: {}, thunkAPI) => {
  try {
    return await academicService.updateTimeSlot({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAyStudents = createAsyncThunk('get-ay-stds', async (id: string, thunkAPI) => {
  try {
    return await academicService.getAyStudents(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAyProStds = createAsyncThunk('getAyProStds', async (data: {}, thunkAPI) => {
  try {
    return await academicService.getAyProStds({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateTimeSlot = createAsyncThunk('create-timeslot', async (data: {}, thunkAPI) => {
  try {
    return await academicService.createTimeSlot({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ProgramPrint = createAsyncThunk('program-print', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/timetable/program-print/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type AcademicsState = {
  record: any
  records: any
  errors: any
}

const initialState: AcademicsState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const academicSlice = createSlice({
  name: 'academic',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListCourse.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(listCourseLessons.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListPublicationCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createPublicationCategory.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListPublicationField.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createPublicationField.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListCampusFaculty.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createCampusFaculty.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListCampusDepartment.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createCampusDepartment.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListPublication.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createPublication.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListVideoLibrary.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createVideoLibrary.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(emailToRelatedStudents.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListTimeTable.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
  },
})

export const {reset} = academicSlice.actions
export default academicSlice.reducer
